import React from 'react'
import { makeStyles, Paper } from '@material-ui/core'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    height: '100%',
    padding: `${theme.spacing(3)}px ${theme.spacing(2)}px`,
    left: 0,
    top: 0,
    zIndex: 99,
    overflow: 'auto',
    userSelect: 'none',
    paddingTop: theme.spacing(1),
    borderWidth: 0,
    borderRightWidth: 1,
    width: theme.app.panelWidth,
    transform: `translateX(-${theme.app.panelWidth}px)`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      width: '100vw',
      transition: `transform 
        ${theme.transitions.duration.short}ms 
        ${theme.transitions.easing.easeInOut}`,
      transform: (props) =>
        props.open ? `translateX(0)` : `translateX(-100%)`
    }
  }
}))

const SidePanel = ({ open, children, ...props }) => {
  const classes = useStyles({ open })
  return (
    <Paper
      className={clsx('side-panel', classes.root)}
      variant="outlined"
      square
      {...props}>
      {children}
    </Paper>
  )
}

export default SidePanel
